import React, { useRef } from 'react';

import { Tooltip } from '@mui/material';


interface Props {
  color: string,
  backgroundColor: string
  text: string
  onClick?: () => void,
  date?: any
  default?: string,
  holidayType?: string,
  dateType?: boolean;
  halfDayType?: any
}


const LeaveEvents = (props: Props) => {

  const mainDiv: any = useRef();

  const mobileCheck = () => {
    if (window.innerWidth >= 768) {
      return false;
    } else {
      return true;
    }
  };

  return (<>
    <div
      ref={mainDiv}
      style={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: props.backgroundColor,
        color: props.color,
        fontSize: mobileCheck() ? 15 : 9,
        textAlign: 'center',
        borderRadius: 3,
        maxWidth: mobileCheck() ? '760px' : '130px',
        fontWeight: 700,
        height: 22,
        marginTop: 3,
        marginLeft: window.innerWidth <= 960 ? 10 : 0,
        width: props.default ? 200 : 'auto'
      }}
    >
      {(props.text === 'Annual Leave' || props.text === 'Casual Leave' || props.text === 'Lieu Leave' || props.text === 'No Pay Leave') ? (
        <Tooltip title={props.text + " - " + (props.dateType ? 'Full Day' : 'Half Day' +" - " + (props.halfDayType ? '(Morning)' : '(Evening)'))} placement="top" >
          <span
            style={{
              cursor: props.onClick ? 'pointer' : 'default',
              paddingRight: 4,
              paddingLeft: 4,
              width:'100%',
              textAlign:'left'
            }}
          >{props.dateType}
            {props.text.length > 15 ? props.text.slice(0, 13) + '...' : props.text}
          </span>
        </Tooltip>
      ) : (
        (props.text === 'Short Leave' && props.halfDayType !=null) ? (
          <Tooltip title={props.text + " - " + (props.halfDayType ? '(Morning)' : '(Evening)')} placement="top" >
          <span
            style={{
              cursor: props.onClick ? 'pointer' : 'default',
              paddingRight: 4,
              paddingLeft: 4,
              width:'100%',
              textAlign:'left'
            }}
          >{props.dateType}
            {props.text.length > 15 ? props.text.slice(0, 13) + '...' : props.text}
          </span>
        </Tooltip> 
        ): (
          <Tooltip title={props.text} placement="top" >
          <span
            style={{
              cursor: props.onClick ? 'pointer' : 'default',
              paddingRight: 4,
              paddingLeft: 4,
              width:'100%',
              textAlign:'left'
            }}
          >{props.dateType}
            {props.text.length > 15 ? props.text.slice(0, 13) + '...' : props.text}
          </span>
        </Tooltip>
        )

          )}

    </div>
  </>
  );
}

export default LeaveEvents;